/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.12",
    versionName: "0.2.0-nightly.2026.4.12",
    versionChannel: "nightly",
    buildDate: "2026-04-12T00:14:25.699Z",
    commitHash: "fc8ca34fb597fab66d7859b4644daeefce46c395",
};
